import React from 'react'
import {BsLinkedin, BsInstagram,BsYoutube} from 'react-icons/bs'
import {FaFacebookF,FaTiktok} from 'react-icons/fa'
import {FaMapMarkerAlt} from 'react-icons/fa'
import {ImWhatsapp} from 'react-icons/im'


const SocialMedia = () => {
  return (
   
    <div className="app__social">

        <div>
     
        <a href="https://api.whatsapp.com/send?phone=+923315991135" target="_blank"> <ImWhatsapp/></a>
      
        </div>

        <div>

        <a href="https://www.google.com/maps/dir/Bahria+Town+Safari+Villas+3,+Rawalpindi,+Islamabad,+Punjab,+Pakistan/dr+emans+dental+care/@33.5545291,73.1256169,18z/data=!3m1!4b1!4m13!4m12!1m5!1m1!1s0x38dfed03abc0299b:0x3f179dd72603e8df!2m2!1d73.1253715!2d33.5551746!1m5!1m1!1s0x38dfed4cd72457c3:0x2a3b66bfb5134a9f!2m2!1d73.1285317!2d33.5538947" 
        target="_blank"><FaMapMarkerAlt/></a>
        </div>
        <div>
        
        <a href="https://www.facebook.com/profile.php?id=100086334284466" target="_blank"> <FaFacebookF/> </a>
       
        </div>
        <div>
        <a href='https://www.linkedin.com/in/dr-eman-afroze-952842148/' target="blank"> <BsLinkedin/> </a>
       
        </div>
        <div>
          
        
        <a href="https://www.instagram.com/dremandental/" target="_blank"> <BsInstagram/> </a>
        </div>
        <div>
          <a href="https://www.youtube.com/channel/UCGY_Z3GqLtLqZFcXi-Ffn0g" target="_blank"> <BsYoutube/></a>
          
        </div>
        <div>
        <FaTiktok/>
        </div>
    </div>
  )
}

export default SocialMedia